import type {FormHTMLAttributes} from 'react';
import React from 'react';
import type {StackProps} from '@tempo/core';
import {VStack} from '@tempo/core';

type FormContainerProps = StackProps & FormHTMLAttributes<HTMLFormElement>;

const FormContainer: React.FC<FormContainerProps> = ({children, ...props}) => {
	return (
		<VStack
			as="form"
			alignItems="initial"
			spacing={{base: 'spacing.xl', md: 'spacing.l'}}
			maxWidth="4xl"
			px="spacing.xl"
			pt="spacing.xl"
			margin="auto"
			{...props}
		>
			{children}
		</VStack>
	);
};

export default FormContainer;
